import { isJson } from 'ava-util/dist/data';

export function toRecord<T>(data?: boolean | number | T): T {
    return typeof data !== 'object' ? ({} as T) : data;
}

export function formatError(error: any): Record<string, any> {
    if (isJson(error)) {
        return JSON.parse(JSON.stringify(error));
    }
    if (error instanceof Error) {
        return {
            message: error.message,
            stack: error.stack || '',
        };
    }
    return {
        message: String(error)
    };
}

export function formatErrors(errors: Array<any>): Array<Record<string, any>> {
    return errors.map(error => formatError(error));
}
